//const api = "http://localhost/museo/app/administrator/sistema/";
//const api = "http://localhost/utm.edu.ec/museo/app/administrator/sistema/";
//const api = "http://museoutm.online/app/administrator/sistema/";
const api = "https://www.utm.edu.ec/museo/app/administrator/sistema/";
export default api;